var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row w-full mx-auto lg:w-page-width mt-24 lg:mt-20 mb-3 lg:mb-6"},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }